import { render } from "./SearchArena.vue?vue&type=template&id=b536c6e0&scoped=true"
import script from "./SearchArena.vue?vue&type=script&lang=js"
export * from "./SearchArena.vue?vue&type=script&lang=js"

import "./SearchArena.vue?vue&type=style&index=0&id=b536c6e0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b536c6e0"

export default script